import { Component, OnChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { NotificationsService } from 'angular2-notifications';
import { GenResponse } from 'app/shared/misc-classes';

@Component({
  selector: 'app-quality-app',
  templateUrl: './quality-app.component.html',
  styleUrls: ['./quality-app.component.css']
})
export class QualityAppComponent implements OnChanges {
  dateSel :number = 0;  
  mId:string = "";
  @Input() selMonth: string;
  @Input() selProductType: string;
  @Input() data: any;
  @Output() updateData = new EventEmitter<any>();
  fieldSelection:number;
  comments:any;
  @ViewChild('childModal') public childModal:ModalDirective;
  constructor(public _dataService:DataService,private _notify:NotificationsService) { }

  ngOnChanges() {
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  openModal(num){
    this.fieldSelection = null;
    this.comments = null;
    this.dateSel = num;
    if(this.data && this.data.data){
        for(var i=0;i<this.data.data.length;i++){
          if(this.data.data[i].day == num){
            this.fieldSelection = this.data.data[i].field_selection;
            this.comments = this.data.data[i].comments
          }
        }
    }
      this.childModal.show();
    
  }
  public hideChildModal():void {
    this.childModal.hide();
  }
  getProductType(type:string){
    if(type){
      return this._dataService.getProductType(type);
    }
  }
  formatMonth(_dateObj:string):string{
    let dateObj = new Date(_dateObj);
    if(dateObj){
      return GenService.getDateFormatStr(dateObj , "MMM-YYYY");
    }
    return '-';
  }
  addColor(num){
    var isFound = false;
    if(this.data && this.data.data){
      for(var i=0;i<this.data.data.length;i++){
        if(this.data.data[i].day == num){
          isFound = true;
          if(this.data.data[i].field_selection == 0){
              return 'green'
          }
          else if(this.data.data[i].field_selection == 1){
            return 'blue'
          }
          else if(this.data.data[i].field_selection == 2){
            return 'red'
          }
          else{
            return 'white'
          }       
        }
      }
    }
    if(!isFound){
      return 'white'
    }
  }
  
  saveData(fs,cm){
    let temp=<any>{};   
    temp.month = new Date(this.selMonth).getMonth()+1;
    temp.year = new Date(this.selMonth).getFullYear();
    temp.productType = this.selProductType;
    if(this.data){
      temp.id = this.data.id
    }    
    temp.type="Quality";
    temp.day = this.dateSel;
    temp.fieldSelection = fs;
    temp.comments = cm;
    this._dataService.saveGembaCardsData(temp).subscribe((resp:GenResponse) => {
      if(resp.docId != ""){
        this._notify.success('Success','Data Saved.',this._dataService.successOptions);
        //this.getGembaCardsData();
        this.updateData.emit();  
        this.childModal.hide();
      }
      else{
        this._notify.error('Failure','Failed to Save.',this._dataService.failureOptions);
      }
    });
  }
}
